import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import "./divider.scss";

const Divider = props => {
  const { orientation, label, className, dataTestId } = props;

  if (!label) {
    if (orientation === "vertical") {
      return (
        <span
          className={cx(className, "oui-divider-vertical")}
          data-testid={dataTestId}
        />
      );
    }
    return (
      <hr
        className={cx(
          className,
          "oui-divider",
          "oui-divider-horizontal",
          "oui-m-0"
        )}
        data-testid={dataTestId}
      />
    );
  }
  return (
    <div
      className={cx(
        className,
        "oui-divider",
        `oui-divider-${orientation}-with-label`
      )}
      data-testid={dataTestId}
    >
      <span className="oui-divider-content">{label}</span>
    </div>
  );
};

Divider.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  label: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

Divider.defaultProps = {
  orientation: "horizontal",
  dataTestId: "orion-divider",
  label: ""
};

Divider.displayName = "OrionDivider";

export default Divider;
